module.exports = __webpack_public_path__ + "img/uniqin_new_logo.580e49e5.png";